import ValidationError from "../validationError";
import PaymentLineItem from "../../../formability/form_builder/models/paymentLineItems/paymentLineItem";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";

export default class PaymentLineItemValidator extends NavigableValidator<PaymentLineItem> {
  _validatorKey: 'paymentLineItem'
  defaultMessage: string = 'must be valid';

  // _validate(model: PaymentLineItem): void {
  //   let workflowStep = null;
  //   const steps: {} = model[this.field];
  //   for (const stepId in model[this.field]) {
  //     workflowStep = steps[stepId];
  //     if (workflowStep.isPaymentStep) {
  //       const valid = PaymentLineItemValidator.isValid(workflowStep);
  //       if (!valid) {
  //         this.errors.push(this.buildValidationError(model, workflowStep));
  //       }
  //     }
  //   }
  // }

  buildValidationError(model: PaymentLineItem, value?) {
    return new ValidationError({
      message: this.options.message || this.defaultMessage,
      displayName: model.getDisplayName(this.field, value),
      errorNavOpts: model.validation.errorNavOpts(this, this.field, value),
      section: this.section
    });
  }

}